import { createFileRoute } from '@tanstack/react-router';

import i18n from '@/i18n/config';
import Home from '@/pages/Home';

export const Route = createFileRoute('/_app/')({
  head: () => {
    const title = i18n.t('home.hero.headline').replace(/\n/g, ' ');
    const description =
      "Services financiers d'excellence. Votre patrimoine, notre priorité. Réglementé par l'AMF (permis 231574).";

    const jsonLd = {
      '@context': 'https://schema.org',
      '@type': 'InsuranceAgency',
      name: 'Services Financiers Assureli',
      description,
      url: 'https://assureli.ca/',
      logo: 'https://assureli.ca/logo-new.png',
      image: 'https://assureli.ca/logo-new.png',
      areaServed: 'CA',
    };

    return {
      meta: [
        { title: `Services Financiers Assureli — ${title}` },
        { name: 'description', content: description },
        {
          property: 'og:title',
          content: `Services Financiers Assureli — ${title}`,
        },
        { property: 'og:description', content: description },
      ],
      scripts: [
        { type: 'application/ld+json', children: JSON.stringify(jsonLd) },
      ],
    };
  },
  component: Home,
});
